<template>

    <div class="user-home-page dashboard-page" :class="{'adjust-apps-container': isSuperAdmin === false && isSuperUser === false}">

        <header4IQ v-if="isSuperAdmin || isSuperUser" :fromapp="'ug'"></header4IQ>
        <headerNew v-else :fromapp="'ug'" :activeApp="activeApp" @switchApp="switchToApp" :showEpalldashboard="showEpalldashboard" :showMsspDashboard="showMsspDashboard"></headerNew>

        <Snackbar
            v-if="showSnackbar"
            :snackbarColor="snackbarColor"
            :snackbarMessage="snackbarMessage"
            @close="closeSnackbar()"
        >
        </Snackbar>
        <nextstepspopup v-if="showModal" :selectedapp='selectedapp' @close="showModal = false"></nextstepspopup>

        <!-- header section end -->
        <app-terms v-if="showTnCView" :app="appNameForTnc" :session="session"></app-terms>

        <AdvancedSearch :enablePopup="advancedSearchPopUp" @togglepopup="(val) => advancedSearchPopUp = val"/>
        <main class="main-container" v-if="!advancedSearchPopUp">

            <!-- card section to save app -->

            <section >
                <v-container fluid grid-list-lg>
                    
                    <v-layout row wrap>
                        <v-flex xl12 class="apps_and_users_tool_bar">
                            <v-toolbar style="color:indigo;" dense flat color="#EFEFEF">
                                <!-- <v-btn icon title="Go back to Companies Page" v-if="isSuperAdmin" id="goBackToTenants" @click="backToTenants()" class="pa-0 ma-0 mb-1">
                                    <v-icon>arrow_back</v-icon>
                                </v-btn>
                                <v-toolbar-title>Companies - {{tenantInfo['name']}} - Apps( {{ getAppsData.length }} )</v-toolbar-title> -->

                                <v-btn-toggle v-model="page" borderless mandatory v-if="isSuperAdmin || isSuperUser" class="rounded-0">
                                    <v-btn value="tenants" v-show="isSuperAdmin || isSuperUser">
                                        <span class="hidden-sm-and-down">Tenants</span>
                                    </v-btn>
                                    <v-btn class="app-button" value="apps">
                                        <span class="hidden-sm-and-down">{{tenantInfo.app_label || 'Apps'}} ( {{ getAppsData.filter(item => enableAdvancedSearch ? tenantSeperatedDetails[tenantInfo['schema_name']].app_id.includes(item.pk) : true).length }} )</span>
                                    </v-btn>

                                    <v-btn value="users" v-show="isTenantAdmin || isSuperAdmin || isSuperUser">
                                        <span class="hidden-sm-and-down">Users</span>
                                    </v-btn>
                                </v-btn-toggle>
                                <!-- <v-layout row wrap class=""> -->
                                <h4 v-if="!(isSuperAdmin || isSuperUser)">{{tenantInfo.app_label || 'Apps'}} ( {{ getAppsData.length }} )</h4>
                                <!-- </v-layout> -->

                                <v-spacer></v-spacer>
                                <span style="display:flex;">
                                    <v-icon title="Search" id="enableAppsSearch" @click="enableSearch = true">search</v-icon>
                                    <v-text-field v-if="enableSearch" class="mt-4" label="Search" append-icon="clear" id="closeAppsSearch" @click:append="closeSearch()" autofocus v-model="searchText">
                                    </v-text-field>
                                </span>
                                <span v-show="isSuperAdmin" style="display:flex;">
                                    <v-icon title="Advanced Search" id="enableSearch" :color="enableAdvancedSearch ? '#e34d25 !important' : ''" @click="(advancedSearchPopUp = !advancedSearchPopUp)">zoom_in</v-icon>&nbsp; &nbsp; 
                                </span>
                                <span v-if="(isSuperAdmin || isSuperUser) && showMsspDashboard">
                                    <v-btn @click="switchToApp({name: 'mssp-dashboard'})" dark color="#736B63" :title="tenantInfo.app_label+' Dashboard'">
                                        <v-icon color="white" dense class="organization-dashboard">icon-dashboard</v-icon>&nbsp;
                                        {{tenantInfo.app_label || 'Organizations'}}
                                    </v-btn>
                                </span>
                                <span v-if="(isSuperAdmin || isSuperUser) && showEpalldashboard">
                                    <v-btn @click="switchToApp({name: 'all-companies-dashboard'})" dark color="#736B63">
                                        All Companies Dashboard
                                    </v-btn>
                                </span>
                                <span v-if="isSuperAdmin || isSuperUser">
                                    <div class="label-temp"> Category:</div>&nbsp; &nbsp;
                                    <v-select v-model="categorySelected" id="categoryDropdown" :items="categoryListDropdown" class="temperature_select"></v-select>
                                </span>
                                <span v-if="isSuperAdmin || isSuperUser" id="includeDisabledApps" @click="disableApps = !disableApps">
                                    <v-icon>{{ disableApps ? 'check_box' : 'check_box_outline_blank'}}</v-icon>&nbsp;
                                    <div class="includeDisabledApps" title="Include disabled apps">Include disabled apps</div>&nbsp;
                                    <div v-if="!disableApps">( {{ filterBy(apps.filter(item => enableAdvancedSearch ? tenantSeperatedDetails[tenantInfo['schema_name']].app_id.includes(item.pk) : true), searchText , ['name'], true, {'category': categorySelected}).length - getAppsData.filter(item => enableAdvancedSearch ? tenantSeperatedDetails[tenantInfo['schema_name']].app_id.includes(item.pk) : true).length}} )</div>
                                </span>
                                <span v-if="isSuperAdmin || isSuperUser" title="Notes"><i class="material-icons" id="showNotes" @click="showNotesPopup()">note</i></span>
                                <!-- IDTI USER CREATION -->
                                <span v-if="isSuperAdmin && !tenantInfo.disabled && createIdtiUserEnable" title="Create App" >
                                    <v-btn @click="idtiUserPopup = true,idtiUserName = ''" dark color="#736B63">
                                        + Create IDTI User
                                    </v-btn>
                                </span>
                                <span v-if="(isSuperAdmin || isTenantAdmin) && !tenantInfo.disabled" title="Create App"
                                        :class="createIdtiUserEnable ? 'disabled' : 'enabled'">
                                    <v-btn @click="displayAppTypes()" dark color="#736B63">
                                        + NEW {{tenantInfo.modified_app_label || modifyTenantInfo() || 'App'}}
                                    </v-btn>
                                </span>
                                <!-- IDTI USER CREATION END  -->
                            </v-toolbar>
                        </v-flex>
                    </v-layout>
                </v-container>
            </section>
            <!-- card section to save app close -->

            <!-- '+' icon Design   -->
            <section>
                <div class="select_app_types_list" v-if="selectType" v-on-clickaway="away">
                    <v-list dense subheader v-if="availableTypes.length > 0">
                        <v-toolbar color="#736B63" dark dense>
                            <v-toolbar-title>Select app type</v-toolbar-title>
                        </v-toolbar>
                        <v-list-item v-for="eachApp in availableTypes" :key="eachApp.display_name" @click="newApp(availableTypes,eachApp.display_name,eachApp.name)" class="each_app_type_in_list_of_apps">
                            <v-list-item-icon>
                                <v-icon class="icon_for_apps">brightness_auto</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-text="eachApp.display_name"></v-list-item-title>
                            </v-list-item-content>
                            <!-- <v-list-item-content><v-icon class="icon_for_apps">brightness_auto</v-icon>{{eachApp.display_name}}</v-list-item-content> -->
                        </v-list-item>
                    </v-list>
                    <v-list v-else>
                        <v-toolbar color="#F54B5E" dark dense>
                            <v-toolbar-title>No Apps selected</v-toolbar-title>
                        </v-toolbar>
                    </v-list>
                </div>
            </section>
            <!-- design end -->

            <!-- IDTI user creation popup -->
            <section>
                <v-layout row justify-center>
                    <v-dialog v-model="idtiUserPopup" persistent max-width="600px">
                        <v-card>
                            <v-card-title>
                                <span class="headline">IDTI User</span>
                            </v-card-title>
                        <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field label="User*" required v-model="idtiUserName"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="idtiUserPopup = false,idtiUserName=''">Close</v-btn>
                            <v-btn @click="createNewIDTIUser()">Save</v-btn>
                        </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-layout>

            </section>

            <!-- IDTI user creation popup END -->

            <section class="apps mt-3">
                <v-container fluid grid-list-lg>
                    <v-layout wrap>
                        <v-flex lg3 v-for="(app,index) in getAppsData.filter(item => enableAdvancedSearch? tenantSeperatedDetails[tenantInfo['schema_name']].app_id.includes(item.pk) : true)" :key="index" class="apps_page">
                            <v-card id="appsCard" class="apps_enable_disable" :class="app.disabled? 'disable': 'enable'">
                                <v-layout class="apps-card"  row wrap>
                                    <v-flex xs4 overflow-hidden class="apps_company-logo">
                                        <div v-if="app['service']['name'] == 'ep'" class="ep-name-logo"></div>
                                        <div v-else class="name-logo">{{app['service']['display_name'] | logoName}}</div>
                                    </v-flex>
                                    <v-flex xs8 class="apps_company-info" v-if="app['service']['name'] == 'ep'">
                                        <v-layout row wrap class="apps_comapny-title">
                                            <v-flex xs10 style="display:flex;">
                                                <v-text-field v-if="index == editableIndex" class="apps_company-service text-field"
                                                v-model="app.name">
                                                </v-text-field>
                                                <span v-else class="apps_company-service" :title="app.name" v-text="app.name"></span>
                                            </v-flex>
                                            <v-flex xs1>
                                                <span v-if="!isSuperUser && !app.ug_role.includes('User') && !app.ug_role.includes('tenantAdmin')">
                                                    <v-btn icon left class="app_settings_icon ma-0" small @click="settingsIndex == app['pk'] ? closeSettings() : openSettings(app['service_details']['app_token'],index, app['service']['name'], app)">
                                                        <v-icon color="grey darken-1">
                                                            {{ settingsIndex == app['pk'] ? 'close' : 'settings' }}
                                                        </v-icon>
                                                    </v-btn>
                                                </span>
                                            </v-flex>
                                        </v-layout>
                                        <div class="apps_card-subcontent" @click="switchApp(app,index)" :class="!app.disabled && app.service.callback && (app['service_details']['node'] != 'Germany' || (app.service.name=='id_monitoring_with_leadgen'|| app.service.name=='id_monitoring' || app.service.name=='id_monitoring_lite')) ? '' : 'disabled'">
                                        <v-layout row wrap class="company-sub-elements">
                                            <v-flex xs6 class="apps_company-subtitle">
                                                <span title="Domains">Domains</span>
                                            </v-flex>
                                            <v-flex xs6 class="apps_company-domins-count">
                                                <span>{{ app['epd_app_status']['domains_count'] }}</span>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap class="company-sub-elements">
                                            <v-flex xs6 class="apps_company-subtitle top-padding">
                                                <v-icon class="alerts_icon">notifications_none</v-icon>
                                            </v-flex>
                                            <v-flex xs6 class="apps_company-alerts-count top-padding">
                                                <span class="count">{{ app['epd_app_status']['alerts_count']}}</span>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap class="company-sub-elements">
                                            <v-flex xs12 class="apps_company-tenant-name top-padding">
                                                <span v-if="isSuperAdmin">4IQ Admin</span>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap class="company-sub-elements">
                                            <v-flex xs1 class="apps_company-date">
                                                <v-icon class="time_icon">access_time</v-icon>
                                            </v-flex>
                                            <v-flex xs6 class="apps_company-date">
                                                <span class="date">{{app['date']}}</span>
                                            </v-flex>
                                        </v-layout>
                                        </div>
                                    </v-flex>

                                    <v-flex xs8 class="apps_company-info" v-else>
                                        <v-layout row wrap>
                                            <v-flex xs12 style="display:flex;">
                                                <span class="apps_company-service" :title="app.service.display_name" v-text="app.service.display_name"></span>
                                                <v-spacer></v-spacer>
                                                <span v-if="!isSuperUser && !app.ug_role.includes('User')">
                                                    <v-btn icon left class="app_settings_icon ma-0" small @click="settingsIndex == app['pk'] ? closeSettings() : openSettings(app['service_details']['app_token'],index, app['service']['name'], app)">
                                                        <v-icon color="grey darken-1">
                                                            {{ settingsIndex == app['pk'] ? 'close' : 'settings' }}
                                                        </v-icon>
                                                    </v-btn>
                                                </span>
                                            </v-flex>
                                            <!-- <v-flex xs12 class="apps_company-username" overflow-hidden>
                                                <span class="apps_company-username" :title="app.desc" v-text="app.desc"></span>
                                            </v-flex> -->
                                        </v-layout>
                                        <v-layout row wrap class="company-sub-elements">
                                            <v-flex xs2 class="apps_company-subtitle">
                                                <v-icon class="user_icon">person_outline</v-icon>
                                            </v-flex>
                                            <v-flex xs9 class="apps_company-domins-count">
                                                 <span class="app-username" :title="app.service_details.username">{{app.service_details.username}}</span>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap class="company-sub-elements">
                                            <v-flex xs2 class="apps_company-subtitle top-padding">
                                                <v-icon>flag</v-icon>
                                            </v-flex>
                                            <v-flex xs6 class="apps_company-alerts-count top-padding">
                                                <span :title="app['service_details']['node']">{{app['service_details']['node']}}</span>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap class="company-sub-elements">
                                            <v-flex xs12 class="apps_company-tenant-name top-padding">
                                                <span v-if="isSuperAdmin">4IQ Admin</span>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap class="company-sub-elements">
                                            <v-flex xs1 class="apps_company-date">
                                                <v-icon class="time_icon">access_time</v-icon>
                                            </v-flex>
                                            <v-flex xs6 class="apps_company-date">
                                                <span class="date">{{app['date']}}</span>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

                                </v-layout>
                                <v-divider class="#8C857E"></v-divider>
                                <v-card-actions v-if="app['service']['name'] == 'ep'">
                                    <v-layout row wrap v-if="index == editableIndex">
                                        <v-flex xs12 style="display:flex;" class="app-card-actions">
                                            <v-spacer></v-spacer>
                                            <v-btn depressed @click="cancelEdit()" class="mr-2">
                                                Cancel
                                            </v-btn>
                                            <v-btn depressed color="#8C857E" dark @click="updateApptoken(app)">
                                                Save
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap v-else>
                                        <v-flex xs12 style="display:flex;" class="app-card-actions customized">
                                            <v-btn icon @click="editAppDetails(app, index)" v-if="!app.disabled">
                                                <v-icon v-if="!isSuperUser" class="edit_icon">icon-edit</v-icon>
                                            </v-btn>
                                            <!-- <v-btn icon @click="enableDisableApp('disable',app)" v-if="!app.disabled">
                                                <v-icon v-if="!isSuperUser" class="delete_icon">delete</v-icon>
                                            </v-btn> -->
                                            <v-btn icon @click="confimationAction(app)" v-if="!app.disabled">
                                                <v-icon v-if="!isSuperUser" class="delete_icon">icon-delete</v-icon>
                                            </v-btn>
                                            <v-spacer></v-spacer>
                                            <v-btn depressed color="#8C857E" dark @click="enableDisableApp('enable',app)" v-if="app.disabled">
                                                Enable
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-card-actions>
                                <v-card-actions v-else>
                                    <v-layout row wrap>
                                        <v-flex xs12 style="display:flex;">
                                            <h3 class="apps_company-name" :title="app.name" v-text="app.name"></h3>
                                            <v-spacer></v-spacer>
                                            <div :class="!app.disabled && !isExpired(app.expiration_date) && app.service.callback && (app['service_details']['node'] != 'Germany' || (app.service.name=='id_monitoring_with_leadgen'|| app.service.name=='id_monitoring' || app.service.name=='id_monitoring_lite')) ? '' : 'disabled'">
                                                <!--Button is visible but unclickable if app is expired -->
                                                <v-btn icon class="enable_B" id="launchApp" :disabled="isExpired(app.expiration_date)" :title="isExpired(app.expiration_date) ? 'App is expired' : 'Launch'" @click="!isExpired(app.expiration_date) && switchApp(app,index)">
                                                    <v-icon v-if="!app.disabled && app.service.callback">open_in_new</v-icon>
                                                </v-btn>
                                            </div>
                                            <!-- Actions menu -->
                                            <v-menu v-if="!isSuperUser && !app['disabled'] && !app.ug_role.includes('User') && !app.ug_role.includes('tenantAdmin') && !app.ug_role.includes('appAdmin')" transition="scale-transition" offset-x right>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon slot="activator" v-on="on" id="openAppMenuBtn">
                                                        <v-icon>more_vert</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <v-list-item @click="showEditApptokenPopup(app)">
                                                        <v-list-item-title>Edit</v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item :class="app.jira_ticket ? '': 'disabled'">
                                                        <v-list-item-title><a target="new" :href="app.jira_ticket" class="cmpny_links">Open JIRA</a></v-list-item-title>
                                                    </v-list-item>
                                                    <v-divider></v-divider>
                                                    <v-list-item @click="openSettings(app['service_details']['app_token'],index, app['service']['name'], app)">
                                                        <v-list-item-title>Settings</v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item style="cursor:pointer;">
                                                        <v-list-item-title>Close</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                            <!-- END - Actions menu -->
                                            <span v-if="isSuperAdmin && !tenantInfo.disabled">
                                                <v-btn v-if="app.disabled" depressed color="#8C857E" dark @click="enableDisableApp('enable',app)" class="mt-1">
                                                    enable
                                                </v-btn>
                                            </span>
                                        </v-flex>
                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                        <v-flex lg3 v-if="showNewApp" class="apps_page">
                            <v-card id="appsCard" class="apps_enable_disable" v-if="showNewApp">
                                <v-layout class="apps-card"  row wrap>
                                    <v-flex xs4 overflow-hidden class="apps_company-logo">
                                        <div class="name-logo"></div>
                                    </v-flex>
                                    <v-flex xs8 class="apps_company-info">
                                        <v-layout row wrap class="apps_comapny-title">
                                            <v-flex xs12 style="display:flex;">
                                                <v-text-field class="apps_company-service text-field pt-1"
                                                label="Name"
                                                color="#8C857E"
                                                v-model="newAppCreationDetails.appName">
                                                </v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap class="company-sub-elements">
                                            <v-flex xs4 class="apps_company-subtitle top-padding">
                                                <span title="Domains">Domains</span>
                                            </v-flex>
                                            <v-flex xs6 class="apps_company-domins-count top-padding">
                                                <span>{{ newAppCreationDetails['domains_count'] || '-' }}</span>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap class="company-sub-elements">
                                            <v-flex xs4 class="apps_company-subtitle top-padding">
                                                <v-icon class="alerts_icon">notifications_none</v-icon>
                                            </v-flex>
                                            <v-flex xs6 class="apps_company-alerts-count top-padding">
                                                <span class="count">{{ newAppCreationDetails['alerts_count'] || '-'}}</span>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap class="company-sub-elements">
                                            <v-flex xs12 class="apps_company-tenant-name top-padding">
                                                <span>4IQ Admin</span>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap class="company-sub-elements">
                                            <v-flex xs1 class="apps_company-date">
                                                <v-icon class="time_icon">access_time</v-icon>
                                            </v-flex>
                                            <v-flex xs6 class="apps_company-date">
                                                <span class="date">{{newAppCreationDetails['date'] || defaultDate}}</span>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-divider class="#8C857E"></v-divider>
                                <v-card-actions>
                                    <v-layout row wrap>
                                        <v-flex xs12 style="display:flex;" class="app-card-actions">
                                            <v-spacer></v-spacer>
                                            <v-btn depressed @click="cancelAppCreation()" class="mr-2">
                                                Cancel
                                            </v-btn>
                                            <v-btn depressed color="#8C857E" dark @click="addNewApp()">
                                                Save
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </section>

            <!-- app creation popup -->
             <section>
                <v-dialog width="60rem" id="appCreationPopup" persistent class="show-info-popup" v-model="appCreationPopup" >
                    <v-card class="popup-card">
                        <div class="user_creation_popup_div">
                            <v-layout row wrap>
                                <v-flex xs1 class="pa-2 ma-2">
                                    <v-icon class="apps_creation_logo">
                                        brightness_auto
                                    </v-icon>
                                </v-flex>
                                <v-flex xs9 class="pa-1 ma-2 mt-4 pt-3">
                                    <h3 v-text="storeSelectedType"></h3>
                                </v-flex>
                            </v-layout>
                            <div>
                                <v-layout row wrap>
                                    <v-flex xs3 class="pt-3 ma-2 pl-2">
                                        App Name *
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            id="appName"
                                            label="App Name"
                                            v-model="newapp.name"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs3 class="pt-3 ma-2 pl-2">
                                        Description
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            id="appDescription"
                                            label="Description"
                                            v-model="newapp.custom_name"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs3 class="pt-3 ma-2 pl-2">
                                        <span>
                                            Data center *
                                        </span>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            id="dataCenter"
                                            label="Data Center"
                                            v-if="editApptoken"
                                            readonly
                                            v-model="newapp.selectedDataCenter"
                                        ></v-text-field>
                                        <v-select v-else v-model="selectedDataCenter" :items="dataCentersList" id="dataCentreDropdown" label="Data center" @change="getIdtiUsers()">
                                        </v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="emptyIdtiUser && !editApptoken">
                                    <v-flex xs3 class="pa-2 ma-2 existingIdtiUser_class">
                                        <v-radio-group v-model="selectUserCreationType">
                                            <v-radio id="useExistingUserRadioBtn" label="Use existing IDTI users *"  value ="false" @click="userCreation('false')">
                                            </v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-select 
                                            id="existingIdtiUsersDropdown"
                                            :items="existingIdtiUsersList" 
                                            label="Use existing IDTI users" 
                                            @change="existingIdtiUser('false')" 
                                            v-model="existingUserIDTI"
                                            :class="selectUserCreationType == 'false' ? 'enable':'disabled'"
                                            :tabindex="selectUserCreationType == 'false' ? '':'-1'">
                                        </v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs3 :class="editApptoken? 'pt-3 ma-2 pl-2' : 'ml-3'">
                                        <span v-if="editApptoken">IDTI User Name*</span>
                                        <v-radio-group v-else v-model="selectUserCreationType">
                                            <v-radio id="useNewUserRadioBtn" label="Create a new user *" value = "true" @click="userCreation('true')">
                                            </v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            id="newIDTIUserName"
                                            label="IDTI User name"
                                            v-model="newapp.user_name"
                                            :readonly="editApptoken"
                                            :class="selectUserCreationType == 'true' ? 'enable':'disabled'"
                                            :tabindex="selectUserCreationType == 'true' ? '':'-1'"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs3 class="pt-3 ma-2 pl-2">
                                        Category *
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-select v-model="newapp.category" :items="appCategoryListDropdown" id="appCategoryDropdown" label="Category">
                                        </v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs3 class="pt-3 ma-2 pl-2">
                                        Jira Ticket
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            id="jiraTicket"
                                            label="JIRA Ticket"
                                            v-model="newapp.jiraTicket"
                                            :rules="ticketValidate">
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs3 class="pt-3 ma-2 pl-2">
                                        Expiration Date
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-menu
                                            class="calendar-menu"
                                            ref="calenderMenu"
                                            v-model="calenderMenu"
                                            :close-on-content-click="false"
                                            :return-value.sync="newapp.expirationDate"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="newapp.expirationDate"
                                                label="Expiration Date"
                                                readonly
                                                clearable
                                                slot="activator" v-on="on"
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker
                                            v-model="newapp.expirationDate"
                                            scrollable
                                            :min="minDateInPicker"
                                            >
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="calenderMenu = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.calenderMenu.save(newapp.expirationDate)">OK</v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                            </div>
                            <v-layout row wrap>
                                <v-flex xs12 class="pa-2 ma-2 save_in_app_creation">
                                    <v-spacer></v-spacer>
                                    <div :class="disableActionBtn? 'disabled' : ''">
                                    <v-btn id="saveAppBtn" class="ma-2" depressed color="grey lighten-3" @click="editApptoken ? updateApptoken() : addNewApp()" :class="(newapp.name && ( newapp.user_name || userNameFlag ) && newapp.category) ? 'enable' : 'disabled'">
                                        save
                                    </v-btn>
                                    </div>
                                    <v-btn id="cancelCreatingAppBtn" class="ma-2" depressed color="grey lighten-3" @click="deleteApp()">
                                        cancel 
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-card>
                </v-dialog>
            </section>
            <!-- app creation popup-end -->

            <!-- app settings -->
            <v-container fluid pa-0 v-if="appSettings && availableAppToken" class="settings_pannel">

                <v-layout>
                    <v-card class="apptoken-title">
                        <span class="title">{{selectedApp.name}}
                            <span v-if="selectedApp.category">{{'- '+selectedApp.category}}</span>
                            <fieldset v-if="selectedApp['type'] == 'ida'" class="mt-4">
                                <legend>Search Sources Config Panel</legend>
                                <span class="hunt-data-sources">
                                    <v-checkbox v-for="dataSource in huntdatasources" :key="dataSource['id']" class="tnccheckbox" v-model="dataSource['status']" :label="dataSource.value" @change="updateDataSource(dataSource,selectedApp['type'])"></v-checkbox>
                                </span>
                                <v-divider></v-divider>
                                <span class="hunt-data-sources">
                                    <v-checkbox class="tnccheckbox hunt-data-sources" v-model="selectedApp['full_password']" :label="`View Full Password`" @change="setViewFullPassword"></v-checkbox>
                                    <v-checkbox class="tnccheckbox hunt-data-sources" v-model="selectedApp['shared_investigation']" :label="`Shared Investigation`" @change="setSharedInvestigation"></v-checkbox>
                                    <v-checkbox class="tnccheckbox hunt-data-sources" v-model="selectedApp['enable_dataBrokers']" :label="`Enable DataBrokers`" @change="setEnableDataBrokers"></v-checkbox>
                                </span>
                            </fieldset>
                            <span v-if="selectedApp['type']=='ep'">
                                <legend class="pt-3">Licences</legend>
                                <v-autocomplete
                                    v-model="domeEnabledLicences"
                                    :items="domeLicencesList"
                                    chips
                                    @input="searchInput=null"
                                    :search-input.sync="searchInput"
                                    multiple
                                    outlined
                                    class="pt-3"
                                    @change="updateLicences(domeEnabledLicences,selectedApp['type'])"
                                ></v-autocomplete>
                            </span>
                        </span>
                    </v-card>
                </v-layout>
                <v-layout wrap class="settings-flex-componant">
                    <v-flex sm12 md4>
                        <ipwhitelist id="ipWhiteListComponent" :apptoken="app_token" :nodeValue="nodeValueForApp"></ipwhitelist>
                    </v-flex>
                    <v-flex sm12 md4>
                        <tokens id="tokensComponent" :apptoken="app_token" :userName="userName" :userToken="userToken" :appid="selectedappid" :nodeValue="nodeValueForApp"></tokens>
                    </v-flex>
                    <v-flex sm12 md4>
                        <bar-line-chart id="barlineChartComponent" :apptoken="app_token" :isalertchart="isalertchart" :nodeValue="nodeValueForApp"></bar-line-chart>
                    </v-flex>
                </v-layout>
                <v-layout class="settings-flex-componant">
                    <v-flex sm12 md6 class="ma-1">
                        <configuration id="configurationComponent" :apps='apps' :apptoken="app_token" :show_notification_configuration="show_notification_configuration" :nodeValue="nodeValueForApp"></configuration>
                    </v-flex>
                    <v-flex sm12 md6 class="ma-1" v-if="!isAppAdmin">
                        <userWithAccess id="userWithAccessComponent" :apptoken="app_token" :nodeValue="nodeValueForApp"></userWithAccess>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex class="ma-1" md12 v-if="isSuperAdmin">
                        <tncconfiguration id="tncConfigurationComponent" :appid='selectedappid' :schemaname="tenantInfo.schema_name" :disabletnc="disabletnc" :nodeValue="nodeValueForApp" @action="enableDisableTNC()"></tncconfiguration>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex class="ma-1" >
                        <v-card flat class="app-settings-footer rounded-0" >
                            <v-btn v-show="showDisableApplicationButton && isSuperAdmin" small dark color="deep-purple darken-3" id="disableApplicationBtn" @click="confimationAction(selectedApp)">
                                Disable the application
                            </v-btn>

                            <v-btn small dark color="deep-purple darken-3" id="closeSettingsBtn" @click="closeSettings()">
                                close
                            </v-btn>
                            <div class="expiration-message">
                                <span>{{expirationMessage}}</span>
                            </div>
                        </v-card>
                    </v-flex>
                </v-layout>

            </v-container>

        </main>
        <confirmationDialog 
                :dialogStatus="showConfirmationDialog"
                :title="'Remove Company'"
                :width="570"
                :eventName="'confirmationDialogActions'"
                :actions="dialogActions"
                @confirmationDialogActions="confirmationDialogActions">
                <span>
                    Are you sure you want to remove {{rowData.name}} ?
                </span>
        </confirmationDialog>
        <NotesComponent
            v-if="notesPopup"
            :notesInfo="notesInfo"
            :notesContent="notesInfo.notes"
            @close="closeNotes();">
        </NotesComponent>
        <div v-scroll="onScroll">

            <v-btn
                v-if="displayScroll"
                title="Scroll to top"
                fixed
                bottom
                right
                small
                fab color="white"
                @click="scrollToTop()"
            >
                <v-icon>arrow_upward</v-icon>
            </v-btn>
        </div>
    </div>

</template>

<script>
import {filterBy, reverse, findBy, filterByRowInObject} from '../../../common/assets/utils/filters.js';
import { mixin as clickaway } from 'vue-clickaway';
import {formateDate} from '../../../common/assets/utils/formats.js';
import {hideLoadIcon, showLoadIcon} from '../../../common/assets/utils/load.js';
import header4IQ from '../../../common/components/header.vue';
import headerNew from '../../../common/components/header-new.vue';
import nextstepspopup from '../subcomponents/next-steps-popup.vue';
import ipwhitelist from './ipwhitelist.vue';
import tokens from './tokens.vue';
import configuration from './configuration.vue';
import tncconfiguration from './tncConfiguration.vue';
import userWithAccess from './user_with_access';
import BarLineChart from '../subcomponents/barlinechart.vue';
import appTerms from '../../../common/components/appTerms.vue';
import NotesComponent from "../subcomponents/notes";
import Snackbar from "../../../common/components/snackbar"
import Vue from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import confirmationDialog from '../../../epsrc/components/common/confirmationDialog';
import AdvancedSearch from "../subcomponents/AdvancedSearch.vue";

export default {
    name: 'apps-Component',
    mixins: [ clickaway ],
    data () {
        return {
            page: 'apps',
            searchInput:null,
            // role variables
            isSuperAdmin: false,
            isSuperUser: false,
            isTenantAdmin:false,
            isAppAdmin:false,
            // variables for snakbar
            showSnackbar: false,
            snackbarColor: null,
            snackbarMessage: null,
            showModal: false,
            selectedapp: 'ep',
            showTnCView: false,
            session: null,

            // IDTI user creation variables
            createIdtiUserEnable: false,
            emptyIdtiUser: false,

            apps: [],
            searchText: '',
            disableApps: false,
            enableSearch: false,
            appSettings:null,
            selectType:false,
            availableTypes:[],
            settingsIndex:-1,
            appCreationPopup:false,
            storeSelectedType:'',
            selectedDataCenter: '',
            selectUserCreationType: "true",
            existingIdtiUsersList:[],
            enableExistingIdtiUser:false,
            newapp: {},
            errorText: false,
            userName:'',
            userToken:'',
            isalertchart: false,
            show_notification_configuration:false,
            selectedappid: null,
            disabletnc: null,
            dataCentersList: [] ,
            existingUser:'',
            userNameFlag : false,
            existingUserIDTI:'',
            nodeValueForApp:'',
            showDisableApplicationButton: true,
            collectionOfAppTypesAndPk : [],
            notesPopup : false,
            notesInfo : {},
            disableActionBtn : false,
            hide:null,
            app_token:'',
            appCategoryListDropdown: ['Internal', 'POC','Production', 'System', 'Testing'],
            ticketValidate : [
                v => (v &&  v.length > 0) ? (/^(http|https):\/\/+[\S\.]+(\.[\S\.])+\S+$/.test(v) ? true : 'Not a valid URL or URL did not starts with http or https') : true,
            ],
            calenderMenu: false,
            minDateInPicker: new Date().toISOString().substr(0, 10),
            categorySelected: 'All',
            categoryListDropdown: ['All', 'Internal', 'POC', 'Production', 'System', 'Testing'],
            selectedApp: {},
            editApptoken: false,
            expirationMessage: null,
            huntdatasources: {},
            domeLicences:{},
            domeLicencesList: [],
            domeEnabledLicences:[],
            // new app designs
            newAppCreationDetails: {},
            showNewApp: false,
            editableIndex: -1,
            idtiUserPopup: false,
            idtiUsersList: [],
            idtiUserName: "",
            dataNode: window.location.hostname == 'localhost' ? 'local' : 'US-East',
            defaultDate: new Date(new Date()).toLocaleDateString('default', {day: '2-digit',month:'short', year:'numeric'}),
            showConfirmationDialog: false,
            rowData: [],
            dialogActions: [
                {'text': 'CANCEL', 'action': 'cancel', 'status': 'enabled'},
                {'text': 'REMOVE', 'action': 'remove', 'status': 'enabled'},
            ],
            defaultAppLabels: [
                {'text': 'Companies', 'value': 'company'},
                {'text': 'Apps', 'value': 'app'},
                {'text': 'Organizations', 'value': 'organization'},
            ],
            appNameForTnc: "",
            activeApp: "apps",
            showEpalldashboard: false,
            showMsspDashboard: false,
            advancedSearchPopUp:false,
            displayScroll: false,

        }
    },
    components: {
        header4IQ,
        BarLineChart,
        nextstepspopup,
        ipwhitelist,
        tokens,
        configuration,
        tncconfiguration,
        userWithAccess,
        appTerms,
        NotesComponent,
        Snackbar,
        confirmationDialog,
        headerNew,
        AdvancedSearch
    },
    created(){
        if(this.loggedInUserInformation){
            this.initializeAppsPageData();
        }else{
            this.initializeData({});
        }
        this.getIdtiUsers();
        this.modifyTenantInfo();
        this.CheckDashboardAccess();
    },
    watch:{
        'newapp.name'(){
            if(this.newapp.name){
                this.newapp.name = (this.newapp.name).trimLeft()
            }
        },
        loggedInUserInformation(){
            if(this.loggedInUserInformation){
                this.initializeAppsPageData();
            }
        },
        appsData(){
            this.formatAppsData();
        },
        allAppTypesData(){
            this.formatAppTypesData();
        },
        page(){
            if(this.page && this.page != 'apps'){
                this.$router.push(`/${this.page}`);
            }
        }
    },
    computed: {
        ...mapState({
            loggedInUserInformation: state => state.loginDetails.loggedInUserInformation,
            tenantInfo: state => state.loginDetails.loggedInUserInformation ? state.loginDetails.loggedInUserInformation['switched_tenant'] : {},
            appsData: state => state.appsDetails.allApps,
            allAppTypesData: state => state.appsDetails.allAppTypes,
            enableAdvancedSearch: state => state.advancedSearchDetails.enableAdvancedSearch,
            tenantSeperatedDetails: state => state.advancedSearchDetails.tenantSeperatedDetails
        }),
        getAppsData(){
            return this.filterBy(this.apps, this.searchText , ['name'], this.disableApps, {'category': this.categorySelected});
        },
        availableAppToken(){
            const self = this;
            const index = this.getAppsData.findIndex( app => app['pk'] == self.selectedappid);
            return index > -1;
        },
    },
    methods: {
        ...mapActions({
            initializeData: 'loginDetails/initializeData',
            getApps: 'appsDetails/getAllAppsData',
            selectAppType: 'appsDetails/getAllAppTypes',
            syncTenantsData: 'tenantDetails/syncTenantsData',
            updatedIDASources: 'appsDetails/updatedSources',
            updatedEPLicences:'appsDetails/updatedLicences',
            updateViewFullPassword: 'appsDetails/updateViewFullPassword',
            updateSharedInvestigation: 'appsDetails/updateSharedInvestigation',
            updateEnableDataBrokers: 'appsDetails/updateEnableDataBrokers',
        }),
        onScroll() {
            this.displayScroll = window.scrollY > 50
        },
        scrollToTop() {
            this.$vuetify.goTo(0);
        },
        // CheckMsspDashboardAccess() {
        //     showLoadIcon();
        //     this.$loading(true);
        //     Vue.http.get('/check_dashboard_access/').then((res) => {
        //         try{
        //             this.showMsspDashboard = res.data.has_access || false;
        //         }
        //         catch(err){
        //             console.log("error is:",err);
        //         }
        //         finally{
        //             self.hide = hideLoadIcon();
        //             if(!self.hide){
        //                 this.$loading(false);
        //             }
        //         }
        //     },(error) => {
        //         self.hide = hideLoadIcon();
        //         if(!self.hide){
        //             this.$loading(false);
        //         }
        //         self.displaySnackbar('error-banner',error.data.message);
        //     });
        // },
        switchToApp(appInfo) {
            this.activeApp = appInfo.name || "apps";
            var rowData = [];
            if (this.getAppsData.length > 0) {
                if (this.activeApp == 'mssp-dashboard' || this.activeApp == 'all-companies-dashboard') {
                    for(let item in this.getAppsData) {
                        let app_type = filterByRowInObject(this.getAppsData[item], 'service.name', {});
                        let app_disabled = filterByRowInObject(this.getAppsData[item], 'disabled', {});
                        if(app_type == 'ep' && !app_disabled) {
                            rowData.push(this.getAppsData[item]);
                        }
                    }
                    this.switchApp(rowData[0], 0, this.activeApp)
                } else {
                    this.switchApp(this.getAppsData[0], 0, this.activeApp)
                }
            }
        },
        modifyTenantInfo() {
            var self = this;
            for( let item in self.defaultAppLabels) {
                if (self.defaultAppLabels[item]['text'] == self.tenantInfo['app_label'])
                    self.tenantInfo['modified_app_label'] = self.defaultAppLabels[item]['value'];
            }
        },
        isExpired(expirationDate) {
            if (!expirationDate) return false; // Treat as not expired if expiration_date is undefined or null
            const currentTime = new Date().getTime();
            const expirationTime = new Date(expirationDate).getTime();
            return expirationTime < currentTime; // True if expiration_date is in the past
        },
        closeSearch(){
            this.enableSearch = false;
            this.searchText = '';
        },

        showNotesPopup(){
            var self = this;
            self.notesPopup = true;
            self.notesInfo = {
                'tenant': self.tenantInfo.domain_name,
                'schemaName': self.tenantInfo.schema_name,
                'notes' : "",
                'username' : self.loggedInUserInformation.username,
                'timeStamp' : new Date()
            }
        },

        displayAppTypes(){
            var self = this;
            if( self.availableTypes.length == 1 && self.availableTypes[0].name == 'ep') {
                self.showNewApp = true;
                self.store_name = self.tenantInfo['selected_apps'][0];
                let scrollBottom = document.body.scrollHeight;
                this.$vuetify.goTo(scrollBottom);
            } else {
                self.selectType = true;
            }
        },

        away(){
          this.selectType = false;
        },

        newApp(item,display_name,type){
            var self = this;
            var today = new Date();
            self.newapp = {
                'app_name' : '',
                'custom_name' : '',
                'created_date' : today,
                'updated_date': today,
                'logo': '',
                'user_name':'',
                'category': '',
                'jiraTicket': '',
                'expirationDate': ''
            };
            self.editApptoken = false;
            self.store_name = type;
            self.existingUserIDTI = '';
            self.selectedDataCenter = '';
            self.enableExistingIdtiUser = false;
            self.existingIdtiUsersList = [];
            self.selectType = false;
            self.storeSelectedType = display_name;
            if (type == "ep") {
                self.showNewApp = !self.showNewApp;
                let scrollBottom = document.body.scrollHeight;
                this.$vuetify.goTo(scrollBottom);
            } else {
                self.appCreationPopup = !self.appCreationPopup;
            }
            var appTypeId = -1;
            for(var i in self.collectionOfAppTypesAndPk){
                if(display_name == Object.keys(self.collectionOfAppTypesAndPk[i])){
                    appTypeId = Object.values(self.collectionOfAppTypesAndPk[i]);
                    break;
                }
            }
            showLoadIcon();
            this.$loading(true);
            Vue.http.get('/get_nodes/',{
                params:{
                    'apptype_id' : Number(appTypeId)
                }
            }).then((res) => {
                try{
                    var data_nodes = res.data;
                    self.dataCentersList = Object.keys(data_nodes);
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            });
        },
        CheckDashboardAccess() {
            showLoadIcon();
            this.$loading(true);
            Vue.http.get('/check_dashboard_access/').then((res) => {
                try{
                    let response = res.data;
                    if (response && response.has_access && response.dashboard == 'mssp_dashboard') {
                        this.showMsspDashboard = res.data.has_access || false;
                    } else {
                        this.showEpalldashboard = res.data.has_access || false;
                    }
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            });
        },
        createNewIDTIUser(){
            var self = this;
            let formData = new FormData();
            formData.append('json',JSON.stringify(
                {
                'username': self.idtiUserName,
                'node': self.dataNode
                }
            ));
            showLoadIcon();
            this.$loading(true);
            Vue.http.post('/create_idti_user/',formData)
            .then((res)=>{
                try{
                    self.displaySnackbar('success-banner', "User created Successfully");
                    self.idtiUserPopup = false;
                    self.idtiUserName = "";
                    self.getIdtiUsers();
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error)=>{
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            });

        },

        closeSettings(){
            var self = this;
            self.appSettings = false;
            self.settingsIndex = -1
            self.userToken = '';
            self.userName = '';
        },

        openSettings(tokens,index, type, appDetails){
            var self = this;
            self.appSettings = true;
            self.settingsIndex = appDetails['pk'];
            self.selectedappid = appDetails['pk'];
            self.selectedApp = {
                name: appDetails['name'],
                category: appDetails['category'],
                type: type,
                full_password: appDetails['full_password'],
                shared_investigation: appDetails['shared_investigation'],
                enable_dataBrokers: appDetails['enable_dataBrokers'],
                service_details: appDetails['service_details']
            }
            self.domeEnabledLicences=[]
            if (type == 'ep') {
                showLoadIcon();
                this.$loading(true);
                Vue.http.get('/dome_licences/', {
                    params:{}
                }).then((res) => {
                    try{
                        let response = res.data.data || {};
                        if (response) {
                            self.domeLicences = res.data ? res.data.data : {};
                            let currentSources = appDetails.updated_ep_licences || [];
                            for (let i=0; i<self.domeLicences.length; i++) {
                                if (currentSources.includes(self.domeLicences[i]['id'])) {
                                    self.domeLicences[i]['status'] = true;
                                    self.domeEnabledLicences.push(self.domeLicences[i]['value'])
                                } else {
                                    self.domeLicences[i]['status'] = false;
                                }
                                self.domeLicencesList.push(self.domeLicences[i]['value'])
                            }
                        }
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                    }
                }, (error) => {
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                    self.displaySnackbar('error-banner',error.data.message);
                });
            }

            if (type == 'ida') {
                showLoadIcon();
                this.$loading(true);
                Vue.http.get('/all_datasources/', {
                    params:{}
                }).then((res) => {
                    try{
                        let response = res.data.data || {};
                        if (response) {
                            self.huntdatasources = res.data ? res.data.data : {};
                            let currentSources = appDetails.updated_sources;
                            for (let i=0; i<self.huntdatasources.length; i++) {
                                if (currentSources.includes(self.huntdatasources[i]['id'])) {
                                    self.huntdatasources[i]['status'] = true;
                                } else {
                                    self.huntdatasources[i]['status'] = false;
                                }
                            }
                        }
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                    }
                }, (error) => {
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                    self.displaySnackbar('error-banner',error.data.message);
                });
            }
            if(appDetails['expiration_date']){
                let expdate = new Date(appDetails['expiration_date']).toUTCString();
                if(appDetails['disabled']){
                    if(appDetails['disabled_by'] === 'InternalSystem'){
                        self.expirationMessage = 'App expired on '+ expdate;
                    } else {
                        self.expirationMessage = 'App Disabled by '+appDetails['disabled_by']+' on '+ new Date(appDetails['disabled_date']);
                    }
                } else{
                    self.expirationMessage = 'Expiration time is: '+ expdate;
                    // const dateDiff = Math.floor((new Date(appDetails['expiration_date']).getTime() - new Date().getTime())/(1000 * 3600 * 24))+1;
                    // if(dateDiff <= 7){
                    //     self.displaySnackbar('warning', ('Apptoken will get expired in '+dateDiff+' days'));
                    // }
                }
            } else {
                self.expirationMessage = 'No Expiration Time';
            }
            self.disabletnc = appDetails['disable_tnc'];
            self.isalertchart = (type == 'id_monitoring' || type == 'id_monitoring_with_leadgen' || type == 'id_monitoring_lite');
            self.show_notification_configuration = (type  == 'id_monitoring' || type == 'id_monitoring_with_leadgen' || type == 'id_monitoring_lite');
            self.app_token = tokens;
            self.userToken = appDetails['service_details']['usertoken'];
            self.userName = appDetails['service_details']['username'];
            self.nodeValueForApp = appDetails['service_details']['node'];
            self.showDisableApplicationButton = !(appDetails.disabled);
        },

        switchApp(app,index, tab='dashboard'){
            var self = this;
            console.log(app,tab);
            self.appNameForTnc = null;
            let formData = new FormData();
            formData.append('json',JSON.stringify({'app_id': app['pk'], 'accepttnc': true, 'is_app': self.activeApp === 'apps', 'active_app': (self.activeApp || null)}));
            showLoadIcon();
            this.$loading(true);
            Vue.http.post("/launchApp/", formData).then((res)=>{
                try{
                    let data = res.data;
                    if (tab == 'mssp-dashboard') {
                        window.location.href = "/apps/mssp/index/?at="+ data['access_id'];
                    } else {
                        // TODO ; Need to remove this later addng this for HuntPlus back to apps functionality..........
                        sessionStorage.setItem('tenantSchemaName', data['schema_name']);
                        if(data['accept_tnc']){
                            self.session = data['access_id'];
                            self.appNameForTnc = data['app_name'];
                            self.showTnCView = true;
                        }else if(data['app_name']){
                            if (data['app_name'] === 'ep') {
                                sessionStorage.setItem('tabName', tab);
                            }
                            window.location.href = "/apps/"+data['app_name']+"/index/?at="+ data['access_id'];
                        }else{
                            // console.log("DOnt know what to do..");
                        }
                    }
                    
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            });
        },

        cancelEdit(){
            var self = this;
            self.editableIndex = -1;
            self.getApps();
        },

        updateApptoken(app){
            var self = this;
            self.appCreationPopup = false;
            self.editableIndex = -1;
            var updatedAppDetails = {};
            if (!app) {
                updatedAppDetails = {
                    'apptoken': self.newapp.apptoken,
                    'action': 'update',
                    'node': self.newapp.selectedDataCenter,
                    'app_name': self.newapp.name,
                    'category': self.newapp.category,
                    'app_description': self.newapp.custom_name,
                    'expiration_date': self.newapp.expirationDate,
                    'jira_ticket': self.newapp.jiraTicket
                }
            } else {
                updatedAppDetails = {
                    'apptoken': app['service_details']['app_token'],
                    'action': 'update',
                    'node': app['service_details']['node'],
                    'app_name': app.name,
                    'category': app.category,
                    'app_description': app['service']['description'],
                    'expiration_date': app.expiration_date,
                    'jira_ticket': app.jira_ticket
                }
            }
            showLoadIcon();
            this.$loading(true);
            Vue.http.put('/apptoken/',updatedAppDetails)
            .then((res)=>{
                try{
                    self.getApps();
                    if (this.isSuperAdmin) {
                        self.displaySnackbar('success-banner', 'AppToken updated Successfully');
                    }
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error)=>{
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            });
        },

        editAppDetails(appDetails, index){
            var self = this;
            self.editableIndex = index;
        },

        confimationAction(data) {
            var self = this;
            self.rowData = data;
            self.showConfirmationDialog = true
        },

        enableDisableApp(action,app){
            var self = this;
            let formData = new FormData();
            let apptoken = app ? app['service_details']['app_token'] : self.app_token;
            let node = app ? app['service_details']['node'] : self.nodeValueForApp;
            formData.append('json',JSON.stringify({'apptoken':apptoken,
            'action':action,
            'node':node
            }))
            showLoadIcon();
            this.$loading(true);
            Vue.http.post('/apptoken/',formData)
            .then((res)=>{
                try{
                    action == 'enable' ? (self.showDisableApplicationButton = true) : (self.appSettings = false,self.settingsIndex = -1);
                    self.getApps();
                    self.appSettings = false;
                    self.settingsIndex = -1;
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
                if (self.isSuperAdmin) {
                    self.displaySnackbar('success-banner', action == 'enable' ? "App Enabled Successfully" : "App Disabled Successfully");
                }
            },(error)=>{
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            });
        },

        showEditApptokenPopup(app){
            const self = this;
            self.appCreationPopup = true;
            self.editApptoken = true;
            self.newapp = {
                'apptoken': app['service_details']['app_token'],
                'name': app.name,
                'custom_name': app.desc,
                'selectedDataCenter': app.service_details.node,
                'user_name':  app.service_details.username,
                'category': app.category,
                'jiraTicket': app.jira_ticket,
                'expirationDate': app.expiration_date ? app.expiration_date.substring(0,10) : null,
            }
        },

        confirmationDialogActions(data) {
            var self = this
            if (data.action == 'remove') {
                self.enableDisableApp('disable',self.rowData)
                self.showConfirmationDialog = false;
            } else {
                self.showConfirmationDialog = false;
            }
        },

        initializeAppsPageData(){
            var self = this;
            self.isSuperAdmin = self.loggedInUserInformation['is_superadmin'];
            self.isSuperUser = self.loggedInUserInformation['is_superuser'];
            // self.isSuperUser = true;
            self.isTenantAdmin = self.loggedInUserInformation['is_tenantadmin'];
            self.isAppAdmin = self.loggedInUserInformation['is_appadmin'];

            if(self.appsData && self.appsData.length == 0){
                self.getApps();
            }else{
                self.formatAppsData();
            }
            if(self.allAppTypesData && self.allAppTypesData.length == 0){
                self.selectAppType();
            }else{
                self.formatAppTypesData();
            }
        },

        backToTenants(){
            this.$router.push('/tenants');
        },

        // Method to route to users page
        // goToUsersPage(){
        //     this.$router.push('/users');
        // },

        closeNotes(){
            var self = this;
            self.notesPopup=false;
            self.notesInfo={};
        },

        formatAppsData(){
            var self = this, newData = [];
            showLoadIcon();
            self.$loading(true);
            try{
                let appsData = self.appsData;
                if(appsData.length){
                    for(var app in appsData){
                        if(appsData.hasOwnProperty(app)){
                            newData.push(appsData[app]['fields']);
                            newData[app]['pk'] = appsData[app]['pk'];
                            newData[app]['documentation'] = appsData[app]['fields']['documentation'] || 'all';
                            newData[app]['has_tnc'] = appsData[app]['fields']['has_tnc'] || false;
                            newData[app]['show_tnc'] = appsData[app]['fields']['show_tnc'] || false;
                            newData[app]['disabletnc'] = appsData[app]['fields']['disabletnc'] || false;
                            newData[app]['ug_role'] = appsData[app]['fields']['ug_role'] || 'User';
                            newData[app]['date'] = new Date(appsData[app]['fields']['last_updated']).toLocaleDateString('default', {day: '2-digit',month:'short', year:'numeric'});
                        }
                    }
                    self.apps = newData;
                    if(newData && newData.length == 1 && newData[0].ug_role.includes('User')){
                        self.switchApp(newData[0],0);
                    }
                } else {
                    self.apps = [];
                }
            }
            catch(err){
                console.log("error is:",err);
            }
            finally{
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
            }
        },

        formatAppTypesData(){
            var self = this;
            showLoadIcon();
            self.$loading(true);
            try{
                self.responseData = self.allAppTypesData;
                self.availableTypes = [];
                let tenantAppTypes = self.tenantInfo.selected_apps;
                for(var item in self.responseData){
                    if(self.availableTypes.length < self.responseData.length) {
                        if (self.loggedInUserInformation.is_superadmin){
                            self.availableTypes.push(self.responseData[item].fields);
                            self.collectionOfAppTypesAndPk[item] = {
                                [self.responseData[item].fields.display_name] : self.responseData[item].pk
                            }
                        } else if(tenantAppTypes.includes(self.responseData[item].fields.name)) {
                            self.availableTypes.push(self.responseData[item].fields);
                            self.collectionOfAppTypesAndPk[item] = {
                                [self.responseData[item].fields.display_name] : self.responseData[item].pk
                            }
                        }
                    }
                }
            }
            catch(err){
                console.log("error is:",err);
            }
            finally{
                self.hide = hideLoadIcon();
                if(!self.hide){
                    self.$loading(false);
                }
            }
        },

        updateDataSource(data,type){
            const self = this;
                self.updatedIDASources({
                    'data_source_id':data.id,
                    'data_source_status':data.status,
                    'apptoken': self.app_token,
                    'node': self.nodeValueForApp,
                    'type':type
                });
            self.getApps();
        },
        updateLicences(data,type){
            const self = this;
                self.updatedEPLicences({
                        'epdata':data,
                        'apptoken':self.app_token,
                        'node':self.nodeValueForApp,
                        'type':type
                });
            self.getApps();
        },

        setViewFullPassword(val) {
            let self = this;
            let info = {'apptoken': self.app_token, 'node': self.nodeValueForApp, 'view_full_password': val,'type':self.selectedApp['type']}
            self.updateViewFullPassword(info)
        },

        setSharedInvestigation(val) {
            let self = this;
            let info = {'apptoken': self.app_token, 'node': self.nodeValueForApp, 'shared_investigation': val,'type':self.selectedApp['type']}
            self.updateSharedInvestigation(info)
        },

        setEnableDataBrokers(val) {
            let self = this;
            let info = {'apptoken': self.app_token, 'node': self.nodeValueForApp, 'enable_dataBrokers': val,'type':self.selectedApp['type']}
            self.updateEnableDataBrokers(info)
        },

        getIdtiUsers(){
            var self = this;
            self.existingIdtiUsersList = [];
            showLoadIcon();
            this.$loading(true);
            Vue.http.get('/get_idti_users/', {
                params:{
                    'node' : self.selectedDataCenter ? self.selectedDataCenter : self.dataNode
                }
            }).then((res) => {
                try{
                    self.existingIdtiUsersList = res.data ? res.data : [];
                    if(self.existingIdtiUsersList.length <= 0){
                        self.createIdtiUserEnable = true;
                        self.emptyIdtiUser = false;
                    }
                    else{
                        self.createIdtiUserEnable = false;
                        self.emptyIdtiUser = true;
                        self.selectUserCreationType = 'false';
                        // Currently we will get only 1 user
                        self.idtiUserName = self.existingIdtiUsersList[0];
                    }
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            }, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            });
        },
        
        userCreation(status){
            var self = this;
            self.selectUserCreationType = status;
        },

        enableDisableTNC(){
            var self = this;
            self.apps[self.apps.findIndex(x => x.pk == self.selectedappid)]['disable_tnc'] = !self.disabletnc;
        },
        
        // createApp(){
        //     var self = this;
        //     var today = new Date();
        //     self.showNewApp = true;
        //     self.newAppCreationDetails = {
        //         'appName': '',
        //         'domains_count': 0,
        //         'alerts_count': 0,
        //         'date': new Date(today).toLocaleDateString('default', {day: '2-digit',month:'short', year:'numeric'})
        //     }
        // },

        cancelAppCreation(){
            var self = this;
            self.showNewApp = false;
            self.newAppCreationDetails = {};
        },

        addNewApp(){
            var self = this, formData = new FormData();
            let app_name = self.newapp.name ? self.newapp.name : self.newAppCreationDetails.appName;
            var app_details = {
                'name': app_name,
                'description': self.newapp.custom_name || '',
                'type' : self.store_name || '',
                'node' : self.selectedDataCenter ? self.selectedDataCenter : self.dataNode,
                'jira_ticket': self.newapp.jiraTicket || '',
                'expiration_date': self.newapp.expirationDate || '',
            };
            // self.store_name indicates app type
            if (self.store_name == 'ep') {
                app_details = {
                    ...app_details,
                    'category': 'Production',
                    'username': self.idtiUserName,
                }
            } else {
                app_details = {
                    ...app_details,
                    'category': self.newapp.category,
                }
                if (self.selectUserCreationType === "true") {
                    app_details['new_username'] = self.newapp['user_name'];
                } else {
                    app_details['username'] = self.existingUserIDTI;
                }
            }
            formData.append('json', JSON.stringify(app_details));
            if(app_name){
                showLoadIcon();
                this.$loading(true);
                Vue.http.post("/createapptoken/", formData)
                .then((res) => {
                    try{
                        self.getApps();
                        self.newapp = {};
                        self.newAppCreationDetails = {};
                        self.showNewApp = false;
                        self.errorText = false;
                        self.selectedapp = self.store_name;
                        // change self.showModel to true when needed
                        self.showModal = false;
                        self.appCreationPopup = false;
                        self.syncTenantsData({from: 'appsPage', tenantDomain: self.tenantInfo['domain_name']});
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                    }
                }, (error) => {
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                    self.displaySnackbar('error-banner',error.data.message);
                });
            }else{
                self.errorText = true;
            }
        },
        
        deleteApp(){
            var self = this;
            self.errorText = false;
            self.newapp = {};
            self.appCreationPopup = false;
            self.appSettings = self.settingsIndex > -1 ? true : false;
            self. selectUserCreationType = "true";
        },

        existingIdtiUser(status){
            var self = this;
            self.enableExistingIdtiUser = true;
            self.userNameFlag = true;
            if(status == 'false'){
                var x = self.existingUserIDTI;
                self.existingUser = x;
            }
        },

        displaySnackbar(color,message){
            var self = this;
            self.showSnackbar = false;
            setTimeout(function(){
                self.showSnackbar = true;
            },100)
            self.snackbarColor = color;
            self.snackbarMessage = message;
        },

        closeSnackbar(){
            var self = this;
            self.showSnackbar = false;
            self.snackbarColor = null;
            self.snackbarMessage = null;
        },
        filterBy,
        reverse,
        findBy,
        formateDate,
        hideLoadIcon,
        showLoadIcon
    },
    filters: {
        logoName(name){
            if(name.length <=3){
                return name;
            }else{
                let aname = name.split(' '), lname = '';
                for (let i = 0; i < aname.length; i++) {
                    lname = lname + aname[i][0];
                }
                return lname.substring(0,3);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.adjust-apps-container {
    padding-left: 3%;
}
.settings-flex-componant > .flex {
    border: 1px solid #EFEFEF;
}
.cmpny_links{
    text-decoration:none;
    color:black;
}
#ipWhiteListComponent,#tokensComponent,#barlineChartComponent{
    margin:1%;
}
.app-settings-footer{
    padding:0.5%;
}
.expiration-message{
    line-height:0.5rem;
}
.v-toolbar{
    .v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
        will-change: box-shadow;
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
    }
}

.v-btn-toggle{
    .v-btn{
        max-width: 11rem;
        max-height:2.5rem;
    }
}
.app-button{
    padding-left: 6.5% !important;
}
.apps_company-domins-count{
    span{
        max-width:11.3rem; 
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
    }
}

@media (max-width: 1390px) {
    .includeDisabledApps {
        width: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>